export const getPickerColor = (value = '#FFFFFF') => {
    if (!value) return '#FFFFFF';
    return typeof value === 'string' ? value : value.toHexString();
};
